//Vendor
export const VENDOR = {
  //ENROLLMENT
  ACTIVE_STEP: "ACTIVE_STEP",
  VEND_FLOW_ENROLLMENT: "VEND_FLOW_ENROLLMENT",
  VEND_INFORMATION: "VEND_INFORMATION",
  COMPANY_INFORMATION: "COMPANY_INFORMATION",
  VEND_DOCUMENTATION: "VEND_DOCUMENTATION",
  VEND_FULL_COMPANY: "VEND_FULL_COMPANY",
  VEND_BANK_ACCOUNT: "VEND_BANK_ACCOUNT",
  VEND_UPD_BANK_INFO: "VEND_UPD_BANK_INFO",
  VEND_UPD_COMPANY_INFO: "VEND_UPD_COMPANY_INFO",
  VEND_UPD_GENERAL_INFO: "VEND_UPD_GENERAL_INFO",
  VEND_UPD_DOCUMENTATION: "VEND_UPD_DOCUMENTATION",
  VEND_UPDATE_LOGISTICSADDRESS: "VEND_UPDATE_LOGISTICSADDRESS",
  VEND_FULL_BANK: "VEND_FULL_BANK",
  CONTACT_PERSON: "CONTACT_PERSON",
  CONTACT_PERSON_BANK: "CONTACT_PERSON_BANK",
  BANK_INFORMATION_LIST: "BANK_INFORMATION_LIST",
  LOGISTICS_POSTAL_ADDRESS: "LOGISTICS_POSTAL_ADDRESS",
  VEND_GENERAL_INFORMATION: "VEND_GENERAL_INFORMATION",
  COMPANY_OWNER: "COMPANY_OWNER",
  VEND_FULL_GENERAL_INFO: "VEND_FULL_GENERAL_INFO",
  VEND_ALL_INFO: "VEND_ALL_INFO",
  CONTRACTOR: "CONTRACTOR",
  STEPS: "STEPS",
  LIST_COUNTRY: "LIST_COUNTRY",
  LIST_PROVINCE: "LIST_PROVINCE",
  LIST_CITY: "LIST_CITY",
  LIST_BANK: "LIST_BANK",
  LIST_TYPE_CONTACT: "LIST_TYPE_CONTACT",
  //CALIFICATION
};

//Contact
export const CONTACT = {
  COMPANY: "COMPANY",
  EXIST: "EXIST",
  RUCVENDOR: "RUCVENDOR",
  VENDOR: "VENDOR",
  CURRENTCONTACT: "CURRENTCONTACT",
  PRIMARYCONTACT: "PRIMARYCONTACT",
  SECONDARYCONTACT: "SECONDARYCONTACT",
  CARRIERCONTACT: "CARRIERCONTACT",
  APPROVALSENT: "APPROVALSENT",
  VENDORCREATED: "VENDORCREATED",
  ISACTIVE: "ISACTIVE",
  CREATED: "CREATED",
  PRIMARY_CREATED: "PRIMARY_CREATED",
  SECONDARY_CREATED: "SECONDARY_CREATED",
  ENROLLMENT: "ENROLLMENT",
  LEGALDOCUMENT: "LEGALDOCUMENT",
  PERSONALDATA: "PERSONALDATA",
  //Vendor
  ACCOUNTSTATUS: "ACCOUNTSTATUS",
  PURCHASE_ORDERS: "PURCHASE_ORDERS",
  PURCH_LINES: "PURCH_LINES",
  START_ENROLLMENT: "START_ENROLLMENT",
  VEND_INFORMATION: "VEND_INFORMATION",
};

//TRANSLATION
export const TRANSLATION = {
  LANGUAGE: "LANGUAGE",
  TRANSLATIONS: "TRANSLATIONS",
};

//Login
export const LOGIN = "LOGIN";
export const WIDTHNAVBAR = "WIDTHNAVBAR";
export const LOGOUT = "LOGOUT";
